import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import store from "@/store";
import http from "@/utils/http";
Vue.use(VueRouter);

// 静态路由表（基础路由，始终存在）
const staticRoutes = [
	{
		path: "/",
		name: "首页",
		component: () => import("../views/HomeView.vue"),
	},
	{
		path: "/login",
		name: "登录",
		component: () => import("../views/LoginView.vue"),
		meta: { public: true }, // 标记为公开页面

	},
	{
		path: "/order/orderInfo",
		name: "查看订单详情",
		component: () => import("../views/order/OrderInfo.vue"),
	},
	{
		path: "/order/ReturnInfo",
		name: "查看退货详情",
		component: () => import("../views/order/ReturnInfo.vue"),
	},
		{
		path: "/base/FileView",
		name: "查看文件",
		component: () => import("../views/base/FileView.vue"),
	},
	{
		path: "*",
		redirect: "/login",
	},
];

/**
 * 从后端获取动态路由（菜单）
 */
async function buildRoutes() {
	let res = await http.post("/menu/perm-list");
	console.log("返回值：", res.data);
	if (res.data.data.length > 0) {
		let resultList = res.data.data;
		let menuList = [];
		resultList.forEach((menu) => {
			console.log("../views" + menu.menuUrl + ".vue");
			menuList.push({
				path: menu.menuUrl,
				name: menu.menuName,
				component: () => import("../views" + menu.menuUrl + ".vue"),
				...menu,
			});
		});
		console.log(menuList);
		return menuList;
	}
	return [];
}

// 创建路由实例（初始仅包含静态路由）
let router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes: staticRoutes,
});

/**
 * 重置路由：移除所有动态添加的路由，恢复到仅静态路由的状态
 */
export function resetRouter() {
	const newRouter = new VueRouter({
		mode: "history",
		base: process.env.BASE_URL,
		routes: staticRoutes,
	});
	router.matcher = newRouter.matcher; // 替换匹配器，丢弃动态路由
}

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
	// 设置页面标题（优先使用 meta.title，否则用默认标题）
	console.log(to);
	if (to.name) {
		document.title = to.name + "-  佳喜祥";
	} else {
		document.title = "佳喜祥后台管理系统";
	}
	const token = sessionStorage.getItem("token");
	if (token) {
		// 已登录状态
		if (to.path === "/login") {
			// 已登录时禁止进入登录页，重定向到首页
			next({ path: "/" });
		} else {
			// 判断是否需要加载动态路由（菜单）
			if (!store.state.menuList || store.state.menuList.length === 0) {
				try {
					const asyncRoutes = await buildRoutes();
					// 存储菜单到 Vuex
					store.commit("SET_MENU_LIST", asyncRoutes);
					// 动态添加路由
					asyncRoutes.forEach((route) => router.addRoute(route));
					// 重新触发当前导航，确保路由已添加
					next({ ...to, replace: true });
				} catch (error) {
					// 加载菜单失败（如 token 过期），清除认证信息并跳转登录页
					store.commit("CLEAR_AUTH");
					// next(`/login?redirect=${to.path}`);
					next(`/login`);
				}
			} else {
				// 已有菜单，直接放行
				next();
			}
		}
	} else {
		// 未登录：先重置路由（清除可能残留的动态路由）
		resetRouter();
		if (to.path === "/login") {
			next(); // 允许访问登录页
		} else {
			// 其他页面重定向到登录页，并携带原目标地址
			next(`/login?redirect=${to.path}`);
		}
	}
});

export default router;
